/* istanbul ignore file */

import { Action } from './action';
import { RecursiveTriggerContainer, RecursiveTriggerContainerFormModel } from './recursive-trigger-container';

class BaseLogicBuilderSet {
    actions: Action[];
}

export class LogicBuilderSet extends BaseLogicBuilderSet {
    triggers: RecursiveTriggerContainer[];
}

export class LogicBuilderSetFormModel extends BaseLogicBuilderSet {
    triggers: RecursiveTriggerContainerFormModel[];
}
